import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { promotions, mobilePromotion } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mt="-1px">
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" m="auto 0" w="100%">
          <CFImage src={promotions} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
